export default class StockTransferStatus {

    static APPROVED = new StockTransferStatus(0, 'Aprovado')
  
    static FAILED = new StockTransferStatus(1, 'Reprovado')
  
    static EXPIRED = new StockTransferStatus(2, 'Expirado')
  
    static WAITING_APPROVAL = new StockTransferStatus(3, 'Aguardando aprovação')
  
    static TRANSFER_FAILURE = new StockTransferStatus(4, 'Falha na transferência')
    
    static allStatus() {
      return [
        StockTransferStatus.APPROVED,
        StockTransferStatus.FAILED,
        StockTransferStatus.EXPIRED,
        StockTransferStatus.WAITING_APPROVAL,
        StockTransferStatus.TRANSFER_FAILURE,
      ]
    }
  
    constructor(value, label) {
      this.value = value
      this.label = label
    }
  }